import React from "react";
import {
  DatatableWrapper,
  Pagination,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Col, Row, Table, Button, Spinner } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./dataTable.css";
import { useEffect } from "react";

const DataTable = ({
  tableData,
  header,
  isPagination = true,
  onPageChange,
  setCurrentPage,
  currentPage,
  pageCount,
  loadingStatus,
}) => {
  return (
    <div className="table-container">
      {loadingStatus ? (
        <div className="text-center">
          <div className="spinner-border text-light" role="status"></div>
        </div>
      ) : (
        <DatatableWrapper
          body={tableData?.length > 0 ? tableData : []}
          headers={header?.length > 0 ? header : []}
          paginationOptionsProps={{
            initialState: {},
          }}
          paginationProps={{
            initialState: {
              page: currentPage,
              maxPage: pageCount,
            },
          }}
        >
          <Table>
            <TableHeader />
            <TableBody />
          </Table>
          <Row>
            <Col lg={12} className="pagination-container">
              {isPagination == true && tableData?.length > 0 ? (
                <Pagination
                  controlledProps={{
                    currentPage: currentPage,
                    maxPage: pageCount,
                    onPaginationChange: (e) => onPageChange(e),
                    alwaysShowPagination: true,
                  }}
                />
              ) : null}
            </Col>
          </Row>
        </DatatableWrapper>
      )}
    </div>
  );
};

export default DataTable;
